module.exports = __webpack_public_path__ + "static/media/hxin.8324402b.png";